import { useTranslation } from "@bounce/i18n"

import type { Interpolations } from "./useInterpolations"
import type StepCompact from "@/components/LuggageStorage/HowItWorks/HowItWorksCompact/types"

import markerImg from "@bounce/assets/big-icons/marker.png"
import starImg from "@bounce/assets/big-icons/star.png"
import headToStoreImg from "@bounce/assets/big-icons/walk.png"

type UseStepsCompactOptions = {
  interpolations: Interpolations
}

export const useStepsCompact = ({ interpolations }: UseStepsCompactOptions): StepCompact[] => {
  const { t } = useTranslation("marketing-ls-poi")

  return [
    {
      src: markerImg,
      title: t("screen.poiScreen.stepsCompact.stepOneTitle", "Choose a storage spot"),
      description: t(
        "screen.poiScreen.stepsCompact.stepOneDescription",
        "Book a convenient Bounce luggage storage spot in a tap.",
      ),
    },
    {
      src: headToStoreImg,
      title: t("screen.poiScreen.stepsCompact.stepTwoTitle", "Drop off your bags"),
      description: t(
        "screen.poiScreen.stepsCompact.stepTwoDescription",
        "Go to the bag storage spot and show your booking to the staff.",
      ),
    },
    {
      src: starImg,
      title: t("screen.poiScreen.stepsCompact.stepThreeTitle", "Enjoy the day"),
      description: t(
        "screen.poiScreen.stepsCompact.stepThreeDescription",
        "Make the most of {{PLACE_NAME}} without baggage!",
        interpolations,
      ),
    },
  ]
}
